import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiModal } from '@jtnews/jtn-ui';
import { tsStoreMixin } from '@jtnews/shared';
import { NoServerRendering } from '@jtnews/shared/no-ssr';

import { ConfirmParams } from '../../../../features/user/feature-confirm-register-modal/src/lib/confirm-register-modal/confirm-register-modal';

import RegisterSuccessForm from './register-success-form';

const MOBILE_MODAL_WIDTH = 320;
const DESKTOP_MODAL_WIDTH = 506;

type Events = {
  onChangeModalState: (isOpen: boolean) => void;
  onShowRegisterModal: void;
  onShowConfirmRegisterModal: ConfirmParams;
  onCloseModal: void;
};

export const REGISTER_SUCCESS_MODAL_NAME = 'register-success-modal';

export default componentFactoryOf<Events>()
  .mixin(tsStoreMixin)
  .create({
    name: 'RegisterSuccessModal',
    model: {
      prop: 'isOpen',
      event: 'changeModalState'
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isMobile(): boolean {
        return this.store.deviceInfo.isMobile && !this.store.deviceInfo.isTablet;
      }
    },
    methods: {
      beforeOpen() {
        this.sendReachGoal('Просмотр', 'viewFirstEntrance');
      },
      closeModal() {
        this.sendReachGoal('Закрыть', 'clickFirstEntrance');
        this.$emit('closeModal');
        this.changeModalState();
      },
      clickedTuneLater() {
        this.sendReachGoal('Настроить позже', 'clickFirstEntrance');

        this.closeModal();
      },
      sendReachGoalToProfile() {
        this.sendReachGoal('Перейти в профиль', 'clickFirstEntrance');
      },
      sendReachGoal(valueName: string, goalName: string) {
        const blockType = 'Контент';
        const fieldType = 'Успешный вход (модалка)';

        this.store.analyticsModule.sendNewReachGoal({
          blockType,
          fieldType,
          valueName,
          goalName
        });
      },
      changeModalState() {
        this.$emit('changeModalState', !this.isOpen);
      }
    },
    render() {
      return (
        <NoServerRendering>
          <JtnUiModal
            isOpen={this.isOpen}
            maxWidth={this.isMobile ? MOBILE_MODAL_WIDTH : DESKTOP_MODAL_WIDTH}
            targetName={REGISTER_SUCCESS_MODAL_NAME}
            dataTest={REGISTER_SUCCESS_MODAL_NAME}
            appendTo="body"
            onToggle={() => this.changeModalState()}
            beforeOpen={() => this.beforeOpen()}
          >
            <RegisterSuccessForm
              onClickedProfile={this.sendReachGoalToProfile}
              onClickedTuneLater={this.clickedTuneLater}
              onCloseModal={this.closeModal}
            />
          </JtnUiModal>
        </NoServerRendering>
      );
    }
  });
